


    if(document.querySelector('.single-product')) {

        if(document.querySelector('.gallery-button')) {
            const gl4 = new Glide('.glide-product', {
                type: "carousel",
                startAt:0,
                perView: 1,
                autoplay: false,
                hoverpause: false,
                animationDuration: 1500,
                gap: 0
            }).mount()

            // Ouverture popup galerie
            const elOpenGallery = document.querySelector('.gallery-button')
            const elGalleryPopUp = document.querySelector('#element-fixed')
            const elGalleryPopUpClose = document.querySelector('.close')

            elOpenGallery.addEventListener('click', (e) => {
                e.preventDefault()
                elGalleryPopUp.classList.add('visible')
            })

            elGalleryPopUpClose.addEventListener('click', () => {
                elGalleryPopUp.classList.remove('visible')
            })
        }


        // special js  gallery style
        if (jQuery(".woocommerce-product-gallery figure").hasClass("gallery-img")) {
            jQuery(".woocommerce-product-gallery").addClass("gallery-style")
        }

        const elsSousservice = document.querySelectorAll('.list-childservice .child-name')

        elsSousservice.forEach(sousservice => {
            sousservice.addEventListener('click', () => {

                const sousServiceChildDescription = sousservice.querySelector('.child-description')
                const sousServiceMoreSign= sousservice.querySelector('.more-sign')

                if(sousServiceChildDescription.classList.contains('active')) {
                    sousServiceChildDescription.classList.remove('active')
                    sousServiceMoreSign.classList.remove('active')
                } else {
                    if(document.querySelector('.list-childservice .child-name .child-description.active')) {
                        document.querySelector('.list-childservice .child-name .child-description.active').classList.remove('active')
                        document.querySelector('.list-childservice .child-name .more-sign.active').classList.remove('active')
                    }
                    sousServiceChildDescription.classList.add('active')
                    sousServiceMoreSign.classList.add('active')
                }

            })
        })

    }



// quantity single-product custom



    // scroll parallax

    var parallaxElements = jQuery('.parallax'),
        parallaxQuantity = parallaxElements.length;

    jQuery(window).on('scroll', function () {
        window.requestAnimationFrame(function () {

            for (var i = 0; i < parallaxQuantity; i++) {
                var currentElement =  parallaxElements.eq(i);
                var scrolled = jQuery(window).scrollTop();

                currentElement.css({
                    'transform': 'translate3d(0,' + scrolled * -0.2 + 'px, 0)'
                });

            }
        });

    });

    // checked input cart shipping option
    jQuery("input:radio").change(function () {
        if (jQuery("input:radio").is(":checked")) {
            alert('checked');
        }
        else {
            alert('unchecked');
        }
    });


    // tabs for checkout
    function setupTabs (){
        document.querySelectorAll('.tab-btn').forEach(button=>{
            button.addEventListener('click',()=>{
                const sidebar = button.parentElement;
                const tabs = sidebar.parentElement;
                const tabNumber = button.dataset.forTab;
                const tabActivate = tabs.querySelector(`.tab-content[data-tab="${tabNumber}"]`)

                sidebar.querySelectorAll('.tab-btn').forEach(button=>{
                    button.classList.remove('tab-btn-active')
                })
                tabs.querySelectorAll('.tab-content').forEach(tab=>{
                    tab.classList.remove('tab-content-active')
                })
                button.classList.add('tab-btn-active')
                tabActivate.classList.add('tab-content-active')
            })
        })
    }
    document.addEventListener('DOMContentLoaded',()=>{
        setupTabs();
    })

    // dom move checkout gift message + select pickup
    if(document.querySelector('.woocommerce-checkout')) {
        jQuery(document).ready(function(){
            jQuery(".woocommerce-additional-fields").insertBefore("#payment");
            jQuery("#orddd-lite-checkout-fields").insertBefore("#payment");
            jQuery(".woocommerce-pickup").insertBefore(".woocommerce-additional-fields__field-gift-message");
        });
    }
